import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Language, LanguageApi } from "@lbsdk/*";
import ISO6391 from "iso-639-1";

@Injectable({
  providedIn: "root",
})
export class LanguageService {
  onLanguagesChanged = new BehaviorSubject<Language[]>([]);

  constructor(private languageApi: LanguageApi) {}

  async getLanguages(): Promise<Language[]> {
    try {
      const languages = (await this.languageApi.find().toPromise()) as Language[];
      this.onLanguagesChanged.next(languages || []);
      return languages || [];
    } catch (_) {
      return [];
    }
  }

  async getLanguageCodes(): Promise<string[]> {
    try {
      const languages = (await this.languageApi.find().toPromise()) as Language[];
      const codes = (languages || [])
        .map((l) => (l && (l.code || ISO6391.getCode(l.name))) || "")
        .filter((c) => !!c);
      const unique = Array.from(new Set(codes));
      if (unique.length) {
        return unique;
      }
      return [];
    } catch (_) {
      return [];
    }
  }
}
